import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout } from '@/layouts/PublicLayout';
import { AdminLayout } from '@/layouts/AdminLayout';
import { ScrollToTop } from '@/components/ScrollToTop';

// Public pages
const HomePage = lazy(() => import('@/pages/public/HomePage'));
const AiVideoPage = lazy(() => import('@/pages/public/AiVideoPage'));
const AiCartoonsPage = lazy(() => import('@/pages/public/AiCartoonsPage'));
const PortfolioPage = lazy(() => import('@/pages/public/PortfolioPage'));
const PortfolioItemPage = lazy(() => import('@/pages/public/PortfolioItemPage'));
const ContactsPage = lazy(() => import('@/pages/public/ContactsPage'));
const PricingPage = lazy(() => import('@/pages/public/PricingPage'));
const ProcessPage = lazy(() => import('@/pages/public/ProcessPage'));
const FaqPage = lazy(() => import('@/pages/public/FaqPage'));
const ServicesPage = lazy(() => import('@/pages/public/ServicesPage'));
const CmsPage = lazy(() => import('@/pages/public/CmsPage'));
const NotFoundPage = lazy(() => import('@/pages/public/NotFoundPage'));

// Admin pages
const AdminLoginPage = lazy(() => import('@/pages/admin/AdminLoginPage'));
const AdminDashboardPage = lazy(() => import('@/pages/admin/AdminDashboardPage'));
const AdminPortfolioPage = lazy(() => import('@/pages/admin/AdminPortfolioPage'));
const AdminMediaPage = lazy(() => import('@/pages/admin/AdminMediaPage'));
const AdminCmsPage = lazy(() => import('@/pages/admin/AdminCmsPage'));
const AdminServicesPage = lazy(() => import('@/pages/admin/AdminServicesPage'));
const AdminLeadsPage = lazy(() => import('@/pages/admin/AdminLeadsPage'));
const AdminDesignPage = lazy(() => import('@/pages/admin/AdminDesignPage'));
const AdminUsersPage = lazy(() => import('@/pages/admin/AdminUsersPage'));
const AdminAuditPage = lazy(() => import('@/pages/admin/AdminAuditPage'));
const AdminSettingsPage = lazy(() => import('@/pages/admin/AdminSettingsPage'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'ai-video', element: <AiVideoPage /> },
      { path: 'ai-cartoons', element: <AiCartoonsPage /> },
      { path: 'portfolio', element: <PortfolioPage /> },
      { path: 'portfolio/:slug', element: <PortfolioItemPage /> },
      { path: 'contacts', element: <ContactsPage /> },
      { path: 'pricing', element: <PricingPage /> },
      { path: 'process', element: <ProcessPage /> },
      { path: 'faq', element: <FaqPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'about', element: <CmsPage slug="about" /> },
      { path: 'privacy', element: <CmsPage slug="privacy" /> },
      { path: 'consent', element: <CmsPage slug="consent" /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: '/admin',
    children: [
      { index: true, element: <Navigate to="/admin/login" replace /> },
      {
        path: 'login',
        element: (
          <>
            <ScrollToTop />
            <AdminLoginPage />
          </>
        ),
      },
      {
        element: <AdminLayout />,
        children: [
          { path: 'dashboard', element: <AdminDashboardPage /> },
          { path: 'portfolio', element: <AdminPortfolioPage /> },
          { path: 'media', element: <AdminMediaPage /> },
          { path: 'cms', element: <AdminCmsPage /> },
          { path: 'services', element: <AdminServicesPage /> },
          { path: 'leads', element: <AdminLeadsPage /> },
          { path: 'design', element: <AdminDesignPage /> },
          { path: 'users', element: <AdminUsersPage /> },
          { path: 'audit', element: <AdminAuditPage /> },
          { path: 'settings', element: <AdminSettingsPage /> },
        ],
      },
    ],
  },
]);